const PIXEL_ID = '2095498077846022'

type FbqFn = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[]
  push?: unknown
  loaded?: boolean
  version?: string
}

interface PixelWindow extends Window {
  fbq?: FbqFn
  _fbq?: FbqFn
}

export function initMetaPixel(): void {
  if (typeof window === 'undefined') return

  const w = window as PixelWindow

  if (!w.fbq) {
    const n: FbqFn = function (...args: unknown[]) {
      if (n.callMethod) {
        n.callMethod.apply(n, args)
      } else {
        n.queue?.push(args)
      }
    } as FbqFn

    w.fbq = n
    if (!w._fbq) w._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const first = document.getElementsByTagName('script')[0]
    first?.parentNode?.insertBefore(script, first)

    const noscript = document.createElement('noscript')
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.alt = ''
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
    noscript.appendChild(img)
    document.body.appendChild(noscript)
  }

  w.fbq?.('init', PIXEL_ID)
  w.fbq?.('track', 'PageView')
}

export function trackInitiateCheckout(): void {
  if (typeof window === 'undefined') return
  ;(window as PixelWindow).fbq?.('track', 'InitiateCheckout', {
    content_name: 'Ruta Fertilidad Masculina',
    value: 15,
    currency: 'USD',
  })
}
